<template>
  <div class="team" id="equipo">
    <b-container fluid="md">
      <b-row align-h="center">
        <b-col class="text-center" lg="8">
          <h1 class="font-weight-bold mb-4">
            Nuestro Equipo
          </h1>
          <p class="font-weight-light">
            Nos define lo humano, la inquietud de mente y el entusiasmo.<br />
            Buscamos la superación constante mediante nuevos desafíos, sean
            éstos grandes o pequeños, a nivel profesional así también como
            personal.
          </p>
        </b-col>
        <b-col sm="12">
          <TeamCarousel
            :team="team"
            @clickMember="memberClicked"
            class="mt-4"
          />
        </b-col>
      </b-row>
    </b-container>
    <Curriculum
      :member="member"
      :open="openCurriculum"
      @close="closeCurriculum"
    />
  </div>
</template>

<script>
import TeamCarousel from "@/components/TeamCarousel";
import Curriculum from "@/components/Curriculum";
import { db } from "@/services/firebase";

export default {
  name: "Team",
  components: {
    TeamCarousel,
    Curriculum
  },
  data() {
    return {
      openCurriculum: false,
      member: {},
      team: [],
      teamOrder: []
    };
  },
  methods: {
    memberClicked(id) {
      this.member = this.team.find((member) => member.id === id);
      this.openCurriculum = true;
    },
    closeCurriculum() {
      this.openCurriculum = false;
    }
  },
  async created() {
    await db
      .collection("order")
      .doc("team")
      .get()
      .then((docs) => {
        this.teamOrder = docs.data().web;
      });
    await db
      .collection("team")
      .get()
      .then((docs) => {
        let teamColl = this.teamOrder;
        docs.forEach(function (doc) {
          let newDoc = doc.data();
          newDoc.id = doc.id;
          let index = teamColl.findIndex((item) => item === newDoc.id);
          teamColl[index] = newDoc;
        });

        // new chunk every 3 elements
        this.team = teamColl;
      });
  }
};
</script>

<style scoped lang="sass">
.team
  margin: 8rem 0
</style>
